import { render } from "./ButtonSocial.vue?vue&type=template&id=47165a67&scoped=true"
import script from "./ButtonSocial.vue?vue&type=script&lang=js"
export * from "./ButtonSocial.vue?vue&type=script&lang=js"

import "./ButtonSocial.vue?vue&type=style&index=0&id=47165a67&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47165a67"]])

export default __exports__